"use client";
import * as React from "react";
const SvgHelpOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.2 12.8h1.6v-1.6H7.2zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4M8 3.2a3.2 3.2 0 0 0-3.2 3.2h1.6c0-.88.72-1.6 1.6-1.6s1.6.72 1.6 1.6c0 1.6-2.4 1.4-2.4 4h1.6c0-1.8 2.4-2 2.4-4A3.2 3.2 0 0 0 8 3.2" }));
export {
  SvgHelpOutlined as default
};
